<template>
  <div v-if="!isEmpty(reviews)">
    <div v-if="isMobile" :class="`${classVariableName}-listing-container-single`">
      <ReviewVue :mobView="true" v-for="review in reviews" :key="review.id" :review="review" :validationConfig="validationConfig"
        :product="product" :setAlert="(message, type) => setAlert(message, type)" :vote="isEmpty(userCurrentReview) || userCurrentReview.id !== review.id" />
    </div>
    <div v-else :class="`${classVariableName}-listing-container`">
      <div :class="`${classVariableName}-listing-column`">
        <ReviewVue v-for="review in getFirstColumnReviews" :key="review.id" :review="review" :product="product"
          :validationConfig="validationConfig" :setAlert="(message, type) => setAlert(message, type)" :vote="isEmpty(userCurrentReview) || userCurrentReview.id !== review.id"
        />
      </div>
      <div :class="`${classVariableName}-listing-column`">
        <ReviewVue v-for="review in getSecondColumnReviews" :key="review.id" :review="review"
          :validationConfig="validationConfig" :product="product" :setAlert="(message, type) => setAlert(message, type)" :vote="isEmpty(userCurrentReview) || userCurrentReview.id !== review.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import { isEmpty, classVariableName } from "../utils";
import ReviewVue from "./Review.vue";

export default defineComponent({
  name: "ReviewList",
  setup() {},
  components: {
    ReviewVue,
  },
  data() {
    return {
      classVariableName: classVariableName
    };
  },
  props: {
    product: Object,
    reviews: {
      type: Array,
      default: [],
    },
    validationConfig: Object,
    userCurrentReview: Object,
    setAlert: Function,
    hasNext: Boolean,
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 430;
    },
    getFirstColumnReviews() {
      return this.reviews.filter((_, index) => index % 2 === 0);
    },
    getSecondColumnReviews() {
      return this.reviews.filter((_, index) => index % 2 === 1);
    },
  },
  methods: {
    isEmpty(val) {
      return isEmpty(val);
    }
  },
});
</script>

<style lang="scss" scoped>
@import "../assets/Review.scss";
</style>
